import Api from "@/services/service-v2";

export const customerByFilter = (payload) =>
  Api().$http.post(`/cap/users/customer-care/customer/filter`, payload);

export const fetchTotalOrder = (payload) =>
  Api().$http.post(`/order/api/v2/order/total-order`, payload);

export const createServiceTicket = (payload) =>
  Api().$http.post(`/servicerequest/ticket/create`, payload);

export const serviceTicketList = (payload) =>
  Api().$http.post(`/servicerequest/ticket/filter`, payload);

export const serviceTicketDetail = (id, payload) =>
  Api().$http.get(
    `/servicerequest/ticket/detail/${id}?tenant=${payload.tenant}`,
    payload
  );

export const orderGraph = (payload) =>
  Api().$http.post(`/order/api/v2/order/total-order-statistic`, payload);

export const createNewAddress = (payload) =>
  Api().$http.post(`/cap/users/customer/add-address`, payload);

export const addressList = () =>
  Api().$http.get(`/cap/users/customer/list-address`);

export const awardList = (payload) =>
  Api().$http.post(`/wallet/v2/wallet/user-history`, payload);

export const awardGraph = (payload) =>
  Api().$http.post(`/wallet/v2/wallet/total-wallet-statistic`, payload);

export const serviceRequestGraph = (payload) =>
  Api().$http.post(`/servicerequest/ticket/ticket-statistics`, payload);

export const getOrderList = (payload) =>
  Api().$http.get(
    `/order/api/v1/get/listbycustomer/${payload.id}?limit=${
      payload.limit
    }&type=${payload.type}&isMaster=${true}&fromDate=${
      payload.fromDate
    }&toDate=${payload.toDate}&orderId=${payload.orderId}&status=${
      payload.status
    }`,
    payload
  );

export const customerDetails = (payload) =>
  Api().$http.get(`/cap/users/customer/detail/${payload.id}`, payload);
